import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import CustomModal from '../../../CustomModal/CustomModal'
import { showCreateSpaceModal } from '../../../../Manage/actions'
import useCheckIsMobileScreen from '../../../../hooks/checkMobileScreen'
import PrivateSpaceIcon from '../PrivateSpaceIcon/PrivateSpaceIcon'
import styles from './SpaceSelectionModal.module.css'

const SpaceSelectionModal = ({
  isOpen,
  onClose,
  spaces = [],
  activeTab,
  onTabChange,
  sites = [],
  siteLimit,
  variant = 'spaces'
}) => {
  const dispatch = useDispatch()
  const hiddenLiveSitesCount = useSelector((state) => state.manage.hiddenLiveSitesCount || 0)
  const { isMobile } = useCheckIsMobileScreen()
  const isMoreVariant = variant === 'more'

  const handleCreateSpace = () => {
    onClose()
    dispatch(showCreateSpaceModal(true))
  }

  const handleSpaceSelect = (tabKey) => {
    onClose()
    onTabChange(tabKey)
  }

  const totalSites = sites.length + hiddenLiveSitesCount

  const spaceTabs = [
    {
      key: 'all',
      name: 'All',
      count: siteLimit !== 999 ? `${totalSites}/${siteLimit}` : totalSites
    },
    ...spaces.map((space) => ({
      key: space.id,
      name: space.name,
      isPrivate: Boolean(space.isPrivate),
      count: sites.filter((site) => site.spaceId === space.id).length
    }))
  ]

  const moreTabs = [
    {
      key: 'deleted',
      name: 'Trash',
      count: null,
      icon: isMobile ? null : '/assets/icons/trash.svg'
    },
    { key: 'archive', name: 'Archive', count: null, icon: isMobile ? null : '/assets/icons/archive-box.svg' }
  ]

  const tabs = isMoreVariant ? moreTabs : spaceTabs

  return (
    <CustomModal show={isOpen} onHide={onClose} centered size="md" enforceFocus={false} className={styles.modal}>
      <div className="p-4">
        <Modal.Header closeButton className={styles.header}>
          <Modal.Title className={styles.title}>{isMoreVariant ? 'More' : 'My Spaces'}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.body}>
          <div className={styles.scrollableContainer}>
            <div className={styles.spacesList}>
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`${styles.spaceItem} ${activeTab === tab.key ? styles.spaceItemActive : ''}`}
                  onClick={() => handleSpaceSelect(tab.key)}
                >
                  <div className={styles.spaceContent}>
                    <div className={styles.spaceNameSection}>
                      {tab.icon ? (
                        <img src={tab.icon} alt={tab.name} className={styles.spaceIcon} />
                      ) : (
                        <span className={styles.spaceName}>
                          {tab.isPrivate && <PrivateSpaceIcon />}
                          {tab.name}
                        </span>
                      )}
                      {tab.count !== null && <span className={styles.spaceCount}>{tab.count}</span>}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {!isMoreVariant && (
            <div className={styles.createSection}>
              <button className={styles.createButton} onClick={handleCreateSpace}>
                <span>+</span>
                Create a new space
              </button>
            </div>
          )}
        </Modal.Body>
      </div>
    </CustomModal>
  )
}

export default SpaceSelectionModal
